module.exports = __webpack_public_path__ + "img/Rectangle_25P.351a6da0.png";